import {Component, Input} from '@angular/core';
import {Game} from "../../../models/game.class";
import {GameService} from "../../../services/game.service";
import {Subscription} from "rxjs";



@Component({
  selector: 'app-game-chunk',
  templateUrl: './game-chunk.component.html',
  styleUrls: ['./game-chunk.component.scss']
})
export class GameChunkComponent {
  @Input() games?: Game[];

  favouriteIds: number[] = [];
  favouritesSubs?: Subscription;

  constructor(
    private gameService: GameService
  ) {  }

  ngOnInit(){
    this.favouritesSubs?.unsubscribe();
    this.favouritesSubs = this.gameService.favouriteGameIds$.subscribe(favouriteIds => {
      this.favouriteIds = favouriteIds
    })
  }


  ngOnDestroy(){
    this.favouritesSubs?.unsubscribe();
  }



}

